import axios from "axios";
import Endpoints from "Constants/campaign/civicactioncenter/endPoints";
import STATE from "Constants/campaign/civicactioncenter/state";

const advocateRecordContext = `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_RECORD}`;
const candidatePreviewsContext = `${STATE.SCOPE_OFFICIALS}/${
  STATE.CANDIDATE_PREVIEWS
}`;
const candidateProfilesContext = `${STATE.SCOPE_OFFICIALS}/${
  STATE.CANDIDATE_PROFILES
}`;
const electedOfficialsPreviewsContext = `${STATE.SCOPE_OFFICIALS}/${
  STATE.ELECTED_OFFICIAL_PREVIEWS
}`;
const electedOfficialsProfilesContext = `${STATE.SCOPE_OFFICIALS}/${
  STATE.ELECTED_OFFICIAL_PROFILES
}`;
const voterInformationContext = `${STATE.SCOPE_CAC}/${STATE.VOTER_INFORMATION}`;

export default class ApiHelper {
  constructor(shortUrl, customerId, store) {
    this.shortUrl = shortUrl;
    this.customerId = customerId;
    this.store = store;
  }

  async getCandidate(candidateId) {
    try {
      const endpoint = this.getEndpoint(
        `${Endpoints.CANDIDATE}/${candidateId}`
      );
      const request = await axios.get(endpoint);

      this.store.dispatch(candidateProfilesContext, request.data);
      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  getEndpoint(uri, params = {}) {
    const queryString = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    return `/${this.shortUrl}/cac-gotv/${uri}?${queryString}`;
  }

  async getLegislator(id) {
    try {
      const endpoint = this.getEndpoint(`${Endpoints.LEGISLATOR}/${id}`);
      const request = await axios.get(endpoint);

      this.store.dispatch(electedOfficialsProfilesContext, request.data);
      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  async getVoterInformation(advocate) {
    const result = {};

    try {
      const endpoint = this.getEndpoint(Endpoints.VOTER_INFORMATION, {
        firstname: advocate.firstname,
        lastname: advocate.lastname,
        address1: advocate.address1,
        zip5: advocate.zip5
      });

      const request = await axios.get(endpoint);

      ({
        pollingLocations: result.locations,
        stateName: result.stateName,
        sidebarLinks: result.sidebarLinks,
        sosInformation: result.sosInformation,
        registrationStatus: result.registrationStatus,
        registrationUrl: result.registrationUrl,
        stateRegistrationInfo: result.stateRegistrationInfo
      } = request.data);

      let lastElectionDate = request.data.elections.length > 0 ? request.data.elections[request.data.elections.length - 1] : {};
      result.calendarDates = {
        gCal: lastElectionDate.election_date_gcal,
        iCal: lastElectionDate.election_date_ical
      }

      result.elections = request.data.elections.map(
        election => {
          return {
            fullDate: election.election_date_full,
            name: election.name
          }
        }
      );

      this.store.dispatch(voterInformationContext, result);
    } catch (e) {
      result.error = e;
    }

    return result;
  }

  async postAdvocate(advocate, includeAllData = false) {
    try {
      let endpoint = this.getEndpoint(Endpoints.ADVOCATE);

      if (includeAllData) {
        endpoint = this.getEndpoint(Endpoints.ADVOCATE_ALL);
      }

      const request = await axios.post(endpoint, advocate);

      this.store.dispatch(advocateRecordContext, request.data);

      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  async postRegisterToVote(advocate, party, race) {
    try {
      const endpoint = this.getEndpoint(Endpoints.REGISTER_TO_VOTE);
      const request = await axios.post(endpoint, {
        ...advocate,
        party,
        race
      });

      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  async searchCandidates(address) {
    try {
      const endpoint = this.getEndpoint(Endpoints.SEARCH_CANDIDATES, {
        address1: address.address1,
        zip5: address.zip5,
        zipcode: address.zipcode
      });
      const request = await axios.get(endpoint);

      this.store.dispatch(candidatePreviewsContext, request.data);
      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  getCandidateImageUrl(candidateId, filename) {
    return `/${this.shortUrl}/cac-gotv/${Endpoints.CANDIDATE_IMAGE}/${this.customerId}/${candidateId}/${filename}`;
  }

  async searchLegislators(address) {
    try {
      const endpoint = this.getEndpoint(Endpoints.SEARCH_LEGISLATORS, {
        address1: address.address1,
        zip5: address.zip5,
        zipcode: address.zipcode
      });
      const request = await axios.get(endpoint);

      this.store.dispatch(electedOfficialsPreviewsContext, request.data);
      return request.data;
    } catch (e) {
      return { error: e };
    }
  }

  async trackAdvocateAction(advocate, action, step = "") {
    try {
      const endpoint = this.getEndpoint(Endpoints.ADVOCATE_ACTION);
      const request = await axios.post(endpoint, {
        advocateId: advocate.id,
        action,
        step
      });

      return request.data;
    } catch (e) {
      return { error: e };
    }
  }
}
